import axiosInstance from '../../services/axios';
import { applyFilters, getAPIEndpoint } from '../../helpers'


export default {
    namespaced: true,
    state: {
        items: [],
        item: {},
        total: 0
    },
    getters: {
        // citizen: (state) => (id) => {
        //     return state.items.filter(p => p.id === Number(id))[0]
        // }

    },
    actions: {
        fetchCitizens({ state, commit }, { filter = {} }) {
            const url = applyFilters(`${getAPIEndpoint()}/citizens`, filter)

            return axiosInstance.get(url).then(res => {

                const citizenArray = res.data.data

                const searchedValue = res.data.searched

                const total = res.data.total ?? 0

                commit('loadCitizens', citizenArray)
                commit('loadTotalCitizen', total)
                commit('searchedValue', searchedValue)


            })
        },
        extractData({ state, commit, label }) {
            const url = applyFilters(`${getAPIEndpoint()}/citizens/extractData`)

            return axiosInstance.get(url, { responseType: 'blob' }).then(res => {



                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'membersData.xlsx'
                link.click()
                URL.revokeObjectURL(link.href)
                // const citizenArray = res.data.data

                // const total = res.data.total ?? 0

                // commit('loadCitizens', citizenArray)
                // commit('loadTotalCitizen', total)


            }).catch(console.error)
        },
        fetchCitizenById({state, commit}, citizenId) {
           
            commit('setCitizen', {resource: 'citizens', item: {}}, )
            return axiosInstance.get(`${getAPIEndpoint()}/citizens/${citizenId}`)
            .then(res => {
                const citizen = res.data.data
                commit('setCitizen', {resource: 'citizens', item:citizen})
                return state.item
            })
        },
        createCitizen({ commit }, formData) {
            return axiosInstance.post(`${getAPIEndpoint()}/citizens`, formData)
                .then(res => {
                    const createdCitizen = res.data.data
                    commit('addCitizen', createdCitizen)
                    return createdCitizen

                })
        },
        deleteCitizenWithId({ commit, state }, id) {
            return axiosInstance.delete(`${getAPIEndpoint()}/citizens/${id}`)
                .then(() => {
                    const updatedItems = [...state.items].filter(citizen => citizen._id !== id);

                    commit('deleteCitizen', updatedItems)
                });
        },
        // updateCitizen({ commit, state }, formData) {

        //     return axiosInstance.patch(`${getAPIEndpoint()}/citizens/${formData._id}`, formData)
        //         .then(res => {
        //             const updatedCitizen = res.data.data.data
        //             const updatedItems = [...state.items].filter(citizen => citizen._id !== formData._id);
        //             updatedItems.unshift(updatedCitizen);
        //             commit('updatedCitizen', updatedItems)
        //         })
        // },
        updateCitizenWithId({ commit, state }, formData) {

            return axiosInstance.patch(`${getAPIEndpoint()}/citizens/${formData._id}`, formData)
                .then(res => {
                    const updatedCitizen = res.data.data
                    const updatedItems = [...state.items].filter(citizen => citizen._id !== formData._id);
                    updatedItems.unshift(updatedCitizen);
                    commit('updateCitizens', updatedItems)
                })
        },
        fetchCitizensCards({ state, commit }, { filter = {} }) {
            const url = applyFilters(`${getAPIEndpoint()}/citizens`, filter)

            return axiosInstance.get(url).then(res => {

                const citizenArray = res.data.data

                const searchedValue = res.data.searched

                const total = res.data.total ?? 0

                commit('loadCitizens', citizenArray)
                commit('loadTotalCitizen', total)
                commit('searchedValue', searchedValue)


            })
        },



    },
    mutations: {
        loadCitizens(state, citizens) {
            return state.items = citizens
        },
        searchedValue(state, searchValue){
            return state.searchedValue = parseInt(searchValue) ? parseInt(searchValue) : 0;
        },
        addCitizen(state, citizen) {
            return state.items.unshift(citizen);
        },
        deleteCitizen(state, updatedItems) {

            return state.items = updatedItems
        },
        setCitizen(state, resource) {
            return state.item = resource
        },
        updateCitizens(state, updatedItems) {
            return state.items = updatedItems
        },
        loadTotalCitizen(state, totalCitizenNumber) {
            return state.total = totalCitizenNumber
        }

    }
}